/**
 * Online
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { selectIsOnline } from '../../services/connection/selectors';

interface Props {
    isOnline: boolean;
    children?: ?React.Node;
}

export class Online extends React.PureComponent<Props> {
    render() {
        const { isOnline, children } = this.props;
        if (!isOnline || !children) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    isOnline: selectIsOnline
});

export default connect(mapStateToProps)(Online);
